<script setup>
import CenterLayout from './CenterLayout.vue'
import {Icon, Input,Textarea} from '@components'
import { ref } from 'vue'

import { useChatCustomizer } from '@store/chatCustomizer';
const $chatCustomizer = useChatCustomizer();

import {useSettings} from '@store/settings';
const $settings = useSettings();

// const questions = ref('Hello! Welcome to Prebook. 👋')
// const caption = ref('Ready to book your appointment super quick? Do you want to add any service?')
</script>

<template>
  <CenterLayout>
    <div class="h-[66px] w-[297px] rounded-md overflow-hidden m-auto mb-10">
      <img @click="$chatCustomizer.changeSecondaryMenu('top-banner')" :src="Image('chat-customizer-top-banner.png')" class="opacity-30 cursor-pointer" alt="">
    </div>

    <div class="mb-10 text-center font-semibold text-lg">...</div>
    <div class="rounded-[14px] p-5 flex flex-col gap-5 bg-white w-[381px] m-auto">
      <div class="flex flex-col gap-3">
        <div class="text-sm font-medium">Questions</div>
        <Input v-model="$settings.settings.chat_widget.welcome_title.question"></Input>
      </div>
      <div class="flex flex-col gap-3">
        <div class="text-sm font-medium">Caption</div>
        <Textarea v-model="$settings.settings.chat_widget.welcome_title.answer"></Textarea>
      </div>
    </div>

    <template #sidebar>
      <div class="mt-[44px]">
        <div class="text-[#101828] text-xs font-semibold">Pro Tips</div>
        <div class="text-[#101828] text-lg font-semibold mt-1">Welcome Title</div>
        <ul class="pl-5 mt-1 text-sm text-[#475467] list-disc">
          <li>Set your welcome title</li>
          <li>Describe your idea in caption</li>
        </ul>
      </div>
    </template>
  </CenterLayout>
</template>


<style>

</style>